// import React, { createContext, useState } from "react";

import { initializeApp as firebaseInitApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import "firebase/auth";

import CONFIG from "./CONFIG";

const firebaseApp = firebaseInitApp(CONFIG.firebaseApp);
const firestore = getFirestore(firebaseApp);

export { firebaseApp, firestore };
